<script setup lang="ts">
import { useOffline } from './use-offline'

interface TProps {
  label?: string
}

const props = withDefaults(defineProps<TProps>(), {
  label: '',
})

const { isOnline } = useOffline()
const popupOpen = ref(false)
const togglePopup = () => {
  popupOpen.value = !popupOpen.value
  if (popupOpen.value) {
    setTimeout(() => {
      popupOpen.value = false
    }, 1500)
  }
}

const popupContainerCss =
  `absolute flex flex-col border border-danger right-0 z-50 mt-2 p-3 origin-top-right` +
  ` rounded-md shadow-md bg-card content-card bg-opacity-90` +
  ` ring-1 ring-black ring-opacity-5` +
  ` focus:outline-none`
</script>

<template>
  <client-only>
    <div v-if="!isOnline" class="relative inline-block text-left">
      <div class="z-50 flex flex-row items-center cursor-pointer">
        <div
          role="button"
          :aria-label="label"
          :aria-expanded="popupOpen"
          tabindex="0"
          class="text-danger hover:text-danger"
          @click.prevent="togglePopup"
          @keydown.space.prevent="togglePopup"
          @keydown.enter.prevent="togglePopup"
        >
          <svg
            class="size-6"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m2 2 20 20" />
            <path d="M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193" />
            <path d="M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07" />
          </svg>
          <span class="sr-only">{{ label }}</span>
        </div>
      </div>
      <div v-if="popupOpen" :class="popupContainerCss">
        <div
          role="button"
          aria-orientation="horizontal"
          class="z-50 whitespace-nowrap flex flex-row items-center gap-x-2 cursor-pointer"
          @click="togglePopup"
        >
          {{ label }}
        </div>
      </div>
    </div>

    <!-- <div v-if="true || !isOnline" class="text-danger flex-inline items-center gap-x-2">
      <svg class="size-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 2 20 20"/><path d="M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193"/><path d="M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07"/></svg>
      <span class="sr-only">{{ label }}</span>
      <span v-if="showLabel">
        {{ label }}
      </span>
    </div> -->
  </client-only>
</template>
